import { render } from "./LimitLocationMaxCap.vue?vue&type=template&id=25205fb0"
import script from "./LimitLocationMaxCap.vue?vue&type=script&lang=js"
export * from "./LimitLocationMaxCap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__